import 'mutationobserver-shim'
import Vue from 'vue'
import './plugins/bootstrap-vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import i18n from './i18n'
import './vee-validate'
import vSelect from 'vue-select'
import VueAxios from 'vue-axios'
import Chartkick from 'vue-chartkick'
import Chart from 'chart.js'

Vue.component('VSelect', vSelect)
Vue.prototype.$axios = axios

Vue.use(VueAxios, axios)
Vue.prototype.$ajax = axios

Vue.config.productionTip = false
Vue.use(Chartkick.use(Chart))

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App)
}).$mount('#app')
